import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";

const Container = styled.div`
  width: 160px;
  background: #ffffff;
  position: absolute;
  left: ${props => (props.position ? props.position.x - 25 : 100)}px;
  top: ${props => (props.position ? props.position.y - 25 : 100)}px;
  border-radius: 4px;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
`;

const Menu = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
`;

const MenuOption = styled.li`
  color: #757575;
  display: block;
  line-height: 28px;
  height: 28px;
  padding: 0 8px;
  font-size: 14px;
  border-bottom: ${props => (props.separate ? "1px solid #eee" : "none")};
  &:hover {
    color: #232323;
    cursor: pointer;
    background: #f5f5f5;
  }
`;

const ContextMenu = ({
  contextMenu,
  contextMenuPosition,
  contextMenuClose,
  selectAll,
  deleteSelected,
  deleteAll,
  bringToFront,
  sendToBack
}) => {
  const node = useRef();
  const handleClickOutside = e => {
    console.log("clicking anywhere");
    if (node.current.contains(e.target)) {
      // inside click
      return;
    }
    // outside click
    contextMenuClose();
  };
  const handleDelete = e => {
    deleteSelected(e);
    contextMenuClose();
  };
  const handleDeleteAll = e => {
    deleteAll(e);
    contextMenuClose();
  };
  const handleSelectAll = e => {
    selectAll(e);
    contextMenuClose();
  };
  const handleBringForward = () => {
    console.log("bring forward");
    contextMenuClose();
  };
  const handleBringToFront = e => {
    e.preventDefault();
    bringToFront(e);
    contextMenuClose();
  };
  const handleSendBackward = () => {
    console.log("send backward");
    contextMenuClose();
  };
  const handleSendToBack = e => {
    console.log("send to back");
    sendToBack(e);
    contextMenuClose();
  };
  useEffect(() => {
    if (contextMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [contextMenu]);
  return (
    <Container position={contextMenuPosition} ref={node}>
      {contextMenu && (
        <Menu>
          <MenuOption onClick={handleBringForward}>Bring Forward</MenuOption>
          <MenuOption onClick={handleBringToFront}>Bring to Front</MenuOption>
          <MenuOption onClick={handleSendBackward}>Send Backward</MenuOption>
          <MenuOption onClick={handleSendToBack} separate>
            Send to Back
          </MenuOption>
          <MenuOption onClick={e => handleSelectAll(e)} separate>
            Select All
          </MenuOption>
          <MenuOption onClick={e => handleDelete(e)}>Delete</MenuOption>
          <MenuOption onClick={e => handleDeleteAll(e)}>Delete All</MenuOption>
        </Menu>
      )}
    </Container>
  );
};

export default ContextMenu;
